(function () {
    'use strict';
    angular
        .module('app')
        .directive('myUiSelect', function () {
            return {
                require: 'uiSelect',
                link: function (scope, element, attrs, $select) {

                    $select.searchInput.on('keydown', function (event) {
                        if (event.keyCode == 9 && $select.items.length == 0) { // tab
                            $select.select(null);
                            $select.close(-1);
                        }
                        else if (event.shiftKey && event.keyCode == 9 && $select.items.length == 0) {
                            setTimeout(function () {
                                scope.$apply(function () {
                                    $select.select(null);
                                    $select.close(-1);
                                })
                            }, 500);
                        }
                    });
                }
            };
        });
    angular
        .module('app')
        .controller('SignUpController', SignUpController);

    SignUpController.$inject = ['$http', '$scope', 'authenticator', '$state', '$rootScope', '$stateParams', 'countries', '$timeout', 'eventTracker'];


    function SignUpController($http, $scope, authenticator, $state, $rootScope, $stateParams, countries, $timeout, eventTracker) {
        var vm = this;
        vm.name = null;
        vm.first_name = null;
        vm.last_name = null;
        vm.country = null;
        vm.post_code = null;
        var params = angular.copy($state.params);
        vm.email = params.user_email;
        vm.emailDisabled = params.user_email != '';
        vm.location = null;
        vm.password = null;
        vm.pass_confirm = null;
        vm.close = close;
        vm.signup = signup;
        vm.login = login;
        vm.error_message = false;
        vm.$onInit = init;
        vm.signUpWithFacebook = signUpWithFacebook;
        vm.terms = terms;
        vm.countries = countries;
        vm.hidePassword = true;
        vm.city = "";
        vm.togglePassword = togglePassword;
        vm.pattern = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9{}_=[+:;'"<,>./?!@#$%^&*()~`|\\ÅåÆæØø-]+)$/;
        vm.lostFocus = lostFocus;
        vm.resetState = resetState;
        vm.resetPostCodeState = resetPostCodeState;
        vm.passwordLostFocus = passwordLostFocus;

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Tilmeld dig - Be My Concert" : "Sign up - Be My Concert";

            $rootScope.header_inverted = false;
            vm.page_number = 1;
            vm.country = "DK"
            if ($stateParams.concert && $stateParams.concert != '') {
                vm.buyTicket = true;
            }
            if ($stateParams.user_info) {
                vm.withFacebookInfo = true;
                vm.user_info = $stateParams.user_info;
                vm.first_name = vm.user_info.user_firstname;
                vm.last_name = vm.user_info.user_lastname;
                vm.email = vm.user_info.user_email;
            } else {
                vm.withFacebookInfo = false;
            }
            $http.get('/app/api/users/country')
                .then(function (response) {
                    if (response.data && response.data.country) {
                        vm.country = response.data.country.iso_code;
                    }
                });
            $timeout(function () {
                var password = document.getElementById('password');
                password.onkeyup = (function (e) {
                    if (!password.value) return;
                    $scope.$apply(function () {
                        vm.password_backup = password.value;
                    });
                });
            }, 0);
            $rootScope.dark_text_header = true;
            $rootScope.separate_page  = true;
            $scope.$on('$destroy', function () {
                $rootScope.dark_text_header = false;
                $rootScope.separate_page  = false;
            });
            if($stateParams.get_data) {
                $http.post('/app/api/user/get/', {user_email: $stateParams.user_email})
                .then(function (response) {
                    vm.first_name = response.data.user_firstname;
                    vm.last_name = response.data.user_lastname;
                    vm.email = response.data.user_email;
                    vm.country = response.data.user_country;
                    vm.post_code = response.data.user_postcode;
                });
            }
        }

        function signup() { //Creates a new user if conditions are met
            var user_data = {
                'first_name': vm.first_name,
                'last_name': vm.last_name,
                'country': vm.country,
                'post_code': vm.post_code,
                'email': vm.email,
                'location': vm.location,
                'password': md5(vm.password),
                'from_concert': $stateParams.concert != undefined
            }
            if (vm.withFacebookInfo) { //From facebook
                user_data.from_facebook = true;
                user_data.user_slug = vm.user_info.user_slug;
                user_data.user_facebook_user_id = vm.user_info.user_facebook_user_id;
                user_data.user_facebook_access_token = vm.user_info.user_facebook_access_token;
                user_data.user_facebook_access_token_expires_at = vm.user_info.user_facebook_access_token_expires_at;
            }

            $http.post('api/users/', user_data)
                .then(function (response) {
                    if (response.data.email_already_exists) {
                        console.log('email_already_exists');
                        vm.email_invalid = true;
                        vm.error_message = 'User with email already exists';
                    } else if (response.data.no_last_name) {
                        console.log('no_last_name');
                        vm.no_last_name = true;
                        vm.error_message = 'No last name inputted';
                    } else if (response.data.user_saved) { //Logs the user in as the newly created user
                        authenticator.login(vm.email, vm.password)
                            .then(function (response) {
                                setTimeout(function () {
                                    $rootScope.$emit('check_login_status');
                                }, 0);

                                eventTracker.userSignup({
                                    country: vm.country
                                });
                                if ($stateParams.concert && $stateParams.concert != '') {
                                    $state.go('buy_tickets', {concert_slug: $stateParams.concert});
                                } else if ($stateParams.backToStateName) {
                                    console.log(1, $stateParams.backToStateName, $stateParams.backToStateParams);
                                    // if the backToStateName has been set in the authResolve in routing
                                    return $state.go($stateParams.backToStateName, $stateParams.backToStateParams)
                                } else {
                                    $state.go('just_signed_up');
                                }
                            });
                    } else {
                        // Error in signup
                    }
                });
        }

        function reload() {
            // necessary to force firefox to wait for close() promise to resolve completly
            setTimeout(function () {
                location.reload();
            }, 1);
        }

        function close() {
            if ($stateParams.backToStateName) {
                console.log(1, $stateParams.backToStateName, $stateParams.backToStateParams);
                // if the backToStateName has been set in the authResolve in routing
                return $state.go($stateParams.backToStateName, $stateParams.backToStateParams)
            } else {
                return $state.go('member');
            }
        }

        function login() {
            $state.go('login');
        }

        function signUpWithFacebook() {
            // prompt for facebook login
            return authenticator.promptFacebookLogin().then(function (facebookResponse) {
                if (facebookResponse && facebookResponse.status === 'connected') {
                    // Logged into your app and Facebook.
                    return saveFacebookUser(facebookResponse.authResponse)
                        .then(function (signupResponse) {
                            // if the user has been saved on the backend
                            if (signupResponse.data && signupResponse.data.facebook_login_validated) {
                                // authenticate the saved user
                                return authenticator.authenticate('', '')
                                    .then(function (response) {
                                        // close the sign up modal
                                        return close().then(reload);
                                    });

                            } else {
                                // TODO error handling
                            }
                        });
                } else {
                    // The person is not logged into your app or we are unable to tell.

                }
            });
        }

        function terms() {
            return $state.go('terms_of_use');
        }

        function saveFacebookUser(data) {
            return $http.post('api/signup/facebook/', data);
        }

        function togglePassword() {
            vm.hidePassword = !vm.hidePassword;
            $timeout(function () {
                vm.password = vm.password_backup;
            }, 0);
            $timeout(function () {
                var password = document.getElementById('password');
                password.onkeyup = (function (e) {
                    if (!password.value) return;
                    $scope.$apply(function () {
                        vm.password_backup = password.value;
                    });
                });
            }, 0);
        }

        function lostFocus(elem) {
            if (elem.$viewValue) {
                elem.$lostFocus = true
            }
            else {
                elem.$lostFocus = false;
            }
        }

        function passwordLostFocus(elem) {
            elem.$lostFocus = true
        }

        function resetState(elem) {
            if (!elem.$viewValue) {
                elem.$lostFocus = false;
            }
        }

        function resetPostCodeState(elem) {
            elem.$lostFocus = true;
        }
    }
})();
